import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

export default function Usersonline({ usuarios }) {
  const PS = process.env.REACT_APP_PUBLIC_SERVER;
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const [friends, setFriends] = useState([]);

  return (
    <>
     
        <div className="inbox-widget">
          <div className="inbox-item">
            <div className="inbox-item-img">
              <img
                src={
                  usuarios.imagemProfil
                    ? PS + usuarios.imagemProfil
                    : PS + "users/noavatar.jpg"
                }
                className="rounded-circle"
                alt=""
              />
            </div>
            <p className="inbox-item-author">{usuarios.username}</p>
            <p className="inbox-item-text"></p>
            <p className="inbox-item-date"></p>
          </div>
        </div>
 
    </>
  );
}
